import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';

import { useNavigateBack } from '@jane/shared/hooks';

import { Modal, QRCodeCallout } from '../../components';
import { useKioskAeropayUser, useKioskUser } from '../../data-access';
import type { RootLoaderType } from '../../data-access';
import { useTypedRouteLoaderData } from '../../hooks';
import qrPng from '../assets/qr-logo.png';

export const LinkBank = () => {
  const { pathname } = useLocation();
  const { storeId } = useTypedRouteLoaderData<RootLoaderType>('root');
  const goBack = useNavigateBack(`stores/${storeId}/menu`);

  const { data: kioskUser } = useKioskUser();
  const { data: aeropayData } = useKioskAeropayUser(
    {
      janeUserId: kioskUser?.id,
    },
    {
      // refetch for aeropay data to check for linked bank accounts
      refetchInterval: 5000,
    }
  );

  const mobileLinkBankUrl = useMemo(() => {
    const { hostname, port, protocol } = window.location;

    const source = pathname.includes('checkout') ? 'checkout' : 'bag';

    return `${protocol}//${hostname}${
      port ? `:${port}` : ''
    }/stores/${storeId}/mobile/link-bank?step=signed-in-welcome&source=${source}`;
  }, [storeId]);

  // watch for linked bank accounts to navigate back
  useEffect(() => {
    if ((aeropayData?.bank_accounts?.length || 0) > 0) {
      goBack();
    }
  }, [aeropayData?.bank_accounts]);

  return (
    <Modal
      appId="root"
      contentLabel="Link Bank"
      onRequestClose={() => goBack()}
      open
      overlayClose
      variant="dialogue"
    >
      <Modal.Content padding={false}>
        <QRCodeCallout
          type="link-bank"
          buttonLabel="Go back"
          onClick={() => goBack()}
          qrCode={qrPng}
          url={mobileLinkBankUrl}
        />
      </Modal.Content>
    </Modal>
  );
};
